import React, { lazy } from "react";
import { Route } from "react-router-dom";
import { RequireInitializedMember } from "routes/utils";

const HomePage = lazy(() => import(/* webpackChunkName: "homepage" */ "pages/homepage"));
const Contact = lazy(() => import(/* webpackChunkName: "contact-us" */ "pages/static/contact"));
const HappyBirthday = lazy(() => import(/* webpackChunkName: "happy-birthday" */ "pages/static/happy-birthday"));
const AnniversaryGift = lazy(() => import(/* webpackChunkName: "anniversary-gift" */ "pages/static/anniversary-gift"));
const PopularName = lazy(() => import(/* webpackChunkName: "popular-name" */ "pages/static/popular-name"));
const PopularNameLanding = lazy(() => import(/* webpackChunkName: "popular-name-landing" */ "pages/static/popular-name-landing"));
const InfographicLanding = lazy(() => import(/* webpackChunkName: "infographic" */ "pages/static/infographic"));
const PoplyLanding = lazy(() => import(/* webpackChunkName: "poply" */ "pages/static/poply"));
const Terms = lazy(() => import(/* webpackChunkName: "terms" */ "pages/static/terms"));
const Privacy = lazy(() => import(/* webpackChunkName: "privacy" */ "pages/static/privacy"));
const About = lazy(() => import(/* webpackChunkName: "about" */ "pages/static/about"));
const ShareLink = lazy(() => import(/* webpackChunkName: "share-link" */ "pages/static/share-link"));
const Testing = lazy(() => import(/* webpackChunkName: "testing" */ "pages/testing"));
const GiftCardWebView = lazy(() => import(/* webpackChunkName: "ios-app-gift-card-webview" */ "pages/ios-app/gift-card-webview"));

const renderStaticRoutes = () => [
  <Route key="homepage" name="homepage" path="/" element={<HomePage />} />,
  <Route key="contact" name="contact" path="/contact" element={<Contact />} />,
  <Route key="poply-landing" name="poply-landing" path="/poply" element={<PoplyLanding />} />,
  <Route key="happy-birthday" name="happy-birthday" path="/happy_birthday" element={<HappyBirthday />} />,
  <Route key="anniversary-gift" name="anniversary-gift" path="/anniversary/gift" element={<AnniversaryGift />} />,
  <Route key="popular-name" name="popular-name" path="/name/:popularName" element={<PopularName />} />,
  <Route key="popular-name" name="popular-name" path="/name" element={<PopularNameLanding />} />,
  <Route
    key="infographic"
    name="infographic"
    path="/infographic"
    element={
      <RequireInitializedMember>
        <InfographicLanding />
      </RequireInitializedMember>
    }
  />,
  <Route
    key="ios-app-gift-card"
    name="ios-app-gift-card"
    path="/ios-app/gift-card"
    element={
      <RequireInitializedMember>
        <GiftCardWebView />
      </RequireInitializedMember>
    }
  />,
  <Route key="terms" name="terms" path="/terms" element={<Terms />} />,
  <Route key="privacy" name="privacy" path="/privacy" element={<Privacy />} />,
  <Route key="about" name="about" path="/about" element={<About />} />,
  <Route key="team" name="team" path="/team" element={<About />} />,
  <Route key="company" name="company" path="/company" element={<About />} />,
  <Route key="copy" name="copy" path="/copy/:linkType/:linkParam" element={<ShareLink />} />,
  <Route key="testing" name="testing" path="/testing" element={<Testing />} />,
];

export default renderStaticRoutes;
